var cart = require('../cart/cart');
var tray = require('../components/tray');
const snackbar = require('../components/snackbar');

var updateMiniCart = true;
var location = window.location;
var LIVE_REGION_ID = 'mk-cart-live-region';
var lastMiniCartAnnouncementKey = null;
var hasPendingMiniCartUpdate = false;
var miniCartAnnouncementRetryTimer = null;
var MINI_CART_ANNOUNCE_RETRY_ATTEMPTS = 10;
var MINI_CART_ANNOUNCE_RETRY_DELAY = 100;

/**
 * Returns an existing cart live region or creates one if missing.
 * @returns {jQuery} Live region element
 */
function getLiveRegion() {
    var $liveRegion = $('.mini-cart-tray:visible .minicart-live-region').first();

    if (!$liveRegion.length) {
        $('body').append(
            '<div id="' + LIVE_REGION_ID + '" class="sr-only" role="status" aria-live="polite" aria-atomic="true"></div>'
        );
        $liveRegion = $('#' + LIVE_REGION_ID);
    }

    return $liveRegion;
}

/**
 * Announces a cart status message via aria-live region.
 * @param {string} message - Announcement message
 */
function announceMiniCartStatus(message) {
    var cleanMessage = (message || '').toString().trim();
    if (!cleanMessage) {
        return;
    }

    var $liveRegion = getLiveRegion();
    $liveRegion.text('');

    setTimeout(function () {
        $liveRegion.text(cleanMessage);
    }, 50);
}

/**
 * Gets the current localized mini-cart state text.
 * @returns {string} Mini-cart state text
 */
function getMiniCartStateText() {
    var cartState = $('.minicart .minicart-link').attr('aria-label');
    return cartState ? cartState.trim() : '';
}

/**
 * Builds a single announcement from message and cart state.
 * @param {string} message - Status message
 * @param {string} cartStateText - Current mini-cart state text
 * @returns {string} Combined announcement
 */
function buildCartAnnouncement(message, cartStateText) {
    var cleanMessage = (message || '').toString().trim();
    var cleanCartState = (cartStateText || '').toString().trim();

    if (!cleanMessage) {
        return cleanCartState;
    }

    if (!cleanCartState) {
        return cleanMessage;
    }

    return cleanMessage + ' ' + cleanCartState;
}

/**
 * Announces mini-cart state when gift-specific content is not available.
 * @returns {boolean} true when fallback message was announced
 */
function announceMiniCartStateFallback() {
    var miniCartState = getMiniCartStateText();
    var miniCartQuantity = $('.minicart .minicart-quantity').first().text().trim();
    var fallbackMessage = miniCartState || miniCartQuantity;

    if (!fallbackMessage) {
        return false;
    }

    var fallbackKey = ['fallback', miniCartState, miniCartQuantity].join('|');
    if (lastMiniCartAnnouncementKey === fallbackKey) {
        return true;
    }

    lastMiniCartAnnouncementKey = fallbackKey;
    announceMiniCartStatus(fallbackMessage);
    return true;
}

/**
 * Builds a bonus gift announcement from rendered gift badge/content.
 * @param {jQuery} $context - Context element containing bonus content
 * @returns {string} Bonus message
 */
function getVisibleMiniCartContainer() {
    var $container = $('.mini-cart-tray .mk-mini-cart:visible').first();

    if (!$container.length) {
        $container = $('.mk-mini-cart:visible').first();
    }

    return $container;
}

/**
 * Builds bonus gift announcement text from mini-cart markup.
 * @param {jQuery} $container - Mini-cart container
 * @returns {string} Announcement text
 */
function getBonusGiftAnnouncementText($container) {
    if (!$container || !$container.length) {
        return '';
    }

    var $bonusContext = $container.find('.minicart-product-container').has('.free-gift-badge').first();
    if (!$bonusContext.length) {
        return '';
    }

    var badgeText = $bonusContext.find('.free-gift-badge').first().text().trim();
    var includedText = $bonusContext.find('.bonus-included-text').first().text().trim();

    return [badgeText, includedText].filter(Boolean).join(' ');
}

/**
 * Announces bonus gift state when mini-cart content updates.
 * @param {boolean} useFallback - whether to use fallback message when gift text is unavailable
 * @returns {boolean} true when announcement was made
 */
function announceBonusGiftFromMiniCart(useFallback) {
    var $miniCartContainer = getVisibleMiniCartContainer();
    if (!$miniCartContainer.length) {
        hasPendingMiniCartUpdate = true;
        return false;
    }

    var giftAnnouncement = getBonusGiftAnnouncementText($miniCartContainer);
    if (!giftAnnouncement) {
        lastMiniCartAnnouncementKey = null;
        hasPendingMiniCartUpdate = true;

        if (useFallback) {
            hasPendingMiniCartUpdate = !announceMiniCartStateFallback();
            return !hasPendingMiniCartUpdate;
        }

        return false;
    }

    var miniCartState = getMiniCartStateText();
    var miniCartQuantity = $('.minicart .minicart-quantity').first().text().trim();
    var announcementMessage = buildCartAnnouncement(giftAnnouncement, miniCartState);
    var announcementKey = [giftAnnouncement, miniCartState, miniCartQuantity].join('|');

    if (lastMiniCartAnnouncementKey === announcementKey) {
        hasPendingMiniCartUpdate = false;
        return true;
    }

    lastMiniCartAnnouncementKey = announcementKey;
    announceMiniCartStatus(announcementMessage);
    hasPendingMiniCartUpdate = false;
    return true;
}

/**
 * Retries pending mini-cart announcement until tray content is ready.
 * @param {boolean} useFallback - whether to use fallback message when gift text is unavailable
 */
function scheduleMiniCartAnnouncementRetry(useFallback) {
    var attemptsLeft = MINI_CART_ANNOUNCE_RETRY_ATTEMPTS;

    if (miniCartAnnouncementRetryTimer) {
        clearTimeout(miniCartAnnouncementRetryTimer);
        miniCartAnnouncementRetryTimer = null;
    }

    /**
     * Executes one retry attempt.
     */
    function tryAnnounce() {
        var isAnnounced = announceBonusGiftFromMiniCart(useFallback);

        if (isAnnounced || attemptsLeft <= 0) {
            miniCartAnnouncementRetryTimer = null;
            return;
        }

        attemptsLeft -= 1;
        miniCartAnnouncementRetryTimer = setTimeout(tryAnnounce, MINI_CART_ANNOUNCE_RETRY_DELAY);
    }

    tryAnnounce();
}

/**
 * Initializes miniCart:updated event handling for accessibility announcements.
 */
function initMiniCartUpdatedEvents() {
    if ($('body').data('mkMiniCartUpdatedEventsReady')) {
        return;
    }

    $('body').data('mkMiniCartUpdatedEventsReady', true);
    $('body').on('miniCart:updated', function () {
        announceBonusGiftFromMiniCart();
    });

    $('body').on('trayModalOpened', function (event, trayData) {
        if (!trayData || !trayData.customClassName || trayData.customClassName.indexOf('mini-cart-tray') === -1) {
            return;
        }

        if (hasPendingMiniCartUpdate) {
            scheduleMiniCartAnnouncementRetry(true);
        }
    });

    $('body').on('tray:closed', function (event, response) {
        if (!response || $(response).hasClass('mini-cart-tray')) {
            hasPendingMiniCartUpdate = false;
            if (miniCartAnnouncementRetryTimer) {
                clearTimeout(miniCartAnnouncementRetryTimer);
                miniCartAnnouncementRetryTimer = null;
            }
        }
    });
}

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessageAndRemoveFromCart(data) {
    $.spinner().stop();
    var status = data.success ? 'success' : 'error';

    snackbar.show({
        position: 'left',
        message: data.msg,
        type: status
    });

    if (!data.itemExists) {
        var $targetElement = $('a[data-pid="' + data.pid + '"]').closest('.product-info').find('.remove-product');
        var itemToMove = {
            actionUrl: $targetElement.data('action'),
            productID: $targetElement.data('pid'),
            productName: $targetElement.data('name'),
            uuid: $targetElement.data('uuid')
        };
        $('body').trigger('afterRemoveFromCart', itemToMove);
        $('.cart-delete-confirmation-btn').trigger('click');
    }
}
/**
 * move items from Cart to wishlist
 * returns json object with success or error message
 */
function moveToWishlist() {
    $('body').on('click', '.product-move .move', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var pid = $(this).data('pid');
        var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
        var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
        var productListName = ($(this).data('product-list-name') || '').toString().toUpperCase();
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal,
                productListName: productListName
            },
            success: function (data) {
                const $wishlistIcon = $('.wishlist-icon');
                const $wishlistFilledIcon = $('.wishlist-filled-icon');
                
                $wishlistIcon.addClass('d-none');
                $wishlistFilledIcon.removeClass('d-none');
                displayMessageAndRemoveFromCart(data);
            },
            error: function (err) {
                displayMessageAndRemoveFromCart(err);
            }
        });
    });
}

module.exports = {
    base:  function() {
        cart();
        initMiniCartUpdatedEvents();

        $('.minicart').on('count:update', function (event, count) {
            if (count && $.isNumeric(count.quantityTotal)) {
                $('.minicart .minicart-quantity').text(count.quantityTotal);
                $('.minicart .minicart-link').attr({
                    'aria-label': count.minicartCountOfItems,
                    title: count.minicartCountOfItems
                });

                $('body').trigger('miniCart:updated', {
                    source: 'count:update',
                    count: count
                });
            }
        });

        $('.minicart').on('mouseenter focusin touchstart', function () {
            if ($('.search:visible').length === 0) {
                return;
            }
            var url = $('.minicart').data('action-url');
            var count = parseInt($('.minicart .minicart-quantity').text(), 10);

            if (count !== 0 && $('.minicart .popover.show').length === 0) {
                if (!updateMiniCart) {
                    $('.minicart .popover').addClass('show');
                    return;
                }

                $('.minicart .popover').addClass('show');
                $('.minicart .popover').spinner().start();
                $.get(url, function (data) {
                    $('.minicart .popover').empty();
                    $('.minicart .popover').append(data);
                    updateMiniCart = false;
                    $.spinner().stop();

                    $('body').trigger('miniCart:updated', {
                        source: 'popover:contentLoaded'
                    });
                });
            }
        });
        $('body').on('touchstart click', function (e) {
            if ($('.minicart').has(e.target).length <= 0) {
                $('.minicart .popover').removeClass('show');
            }
        });
        $('.minicart').on('mouseleave focusout', function (event) {
            if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0)
                || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
                || $('body').hasClass('modal-open')) {
                event.stopPropagation();
                return;
            }
            $('.minicart .popover').removeClass('show');
        });
        $('body').on('change', '.minicart .quantity', function () {
            if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
                location.reload();
            }
        });
        $('body').on('product:afterAddToCart', function () {
            updateMiniCart = true;
        });
        $('body').on('cart:update', function () {
            updateMiniCart = true;
        });
    },
    moveToWishlist: moveToWishlist,

    minicartCountUpdate: function() {
        $('.minicart').on('count:update', function (event, count) {
            if (count && $.isNumeric(count.quantityTotal)) {
                $('.minicart .minicart-quantity').text(count.quantityTotal);
                $('.minicart .minicart-link').attr({
                    'aria-label': count.minicartCountOfItems,
                    title: count.minicartCountOfItems
                });
                if ($.isNumeric(count.quantityTotal) === 0) {
                    $('.minicart .minicart-icon-text').removeClass('active')
                } else {
                    $('.minicart .minicart-icon-text').addClass('active')
                }
            }
        });
    },

    minicartEmptyShow: function () {
        $('.minicart').on('click', function (e) {
            e.preventDefault();
            tray.InitTrayModal();
        });
    },
    miniCartShow: function() {
        $('.minicart .minicart-link ').trigger('click');
    }
};
